import { AddTenantRequestSchema, AddTenantResponseSchema } from './add-tenant.schema';
/**
 * Add Tenant Endpoint Contract
 * Creates a new tenant in the system
 * Restricted to super-admin users only
 */ export const addTenantContract = {
    method: 'POST',
    path: '/api/v2/tenant',
    description: 'Create a new tenant with specified name, slug, and type',
    requestSchema: AddTenantRequestSchema,
    responseSchema: AddTenantResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin'
        }
    }
};

//# sourceMappingURL=add-tenant.contract.js.map